import { render } from "./DragDropFileUpload.vue?vue&type=template&id=2cab43a8&scoped=true&ts=true"
import script from "./DragDropFileUpload.vue?vue&type=script&lang=ts"
export * from "./DragDropFileUpload.vue?vue&type=script&lang=ts"

import "./DragDropFileUpload.vue?vue&type=style&index=0&id=2cab43a8&scoped=true&lang=scss"
import "./DragDropFileUpload.vue?vue&type=style&index=1&id=2cab43a8&lang=scss"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cab43a8"]])

export default __exports__